import Vue from "vue"
import VueRouter from "vue-router"
import Home from "../views/Home.vue"

Vue.use(VueRouter)

const routes = [
  {
    path: "/",
    name: "Home",
    component: Home,
  },
  {
    path: "/index",
    name: "index",

    component: () => import("../views/index.vue"),
  },
  {
    path: "/about",
    name: "About",

    component: () => import("../views/About.vue"),
  },
  {
    path: "/info",
    name: "info",

    component: () => import("../views/info.vue"),
  },
  {
    path: "/mobile",
    name: "mobile",

    component: () => import("../views/mobile.vue"),
  },
]

const router = new VueRouter({
  mode:'history',
  routes,
})

export default router
